<template>
    <div>
        <a v-if="url" :href="url" class="btn btn-primary">Open in checkout</a>
        <a v-else class="btn btn-primary disabled" disabled>Open in checkout</a>
    </div>
</template>

<script>
    import endpointWatcher from './endpointWatcher';

    export default {
        name: "CheckoutEndpointButton",
        props: ['eventId'],
        mounted() {
            this.endpoint = endpointWatcher.getValue();
            this.callback = (value) => {
                this.endpoint = value;
            };

            endpointWatcher.addListener(this.callback);
        },
        computed: {
            url: function () {
                let endpoint = this.endpoint;

                if(endpoint && endpoint.substr(-1) === '/') {
                    endpoint = endpoint.substr(0, endpoint.length - 1);
                }

                if (this.endpoint && this.eventId) {
                    return `${endpoint}/ticket/${this.eventId}`;
                }

                return null;
            }
        },
        data: () => ({
            endpoint: null,
            callback: null
        }),
        beforeDestroy() {
            endpointWatcher.removeListener(this.callback);
        }
    };
</script>

<style scoped>

</style>
